import { toHeaders, doFetch } from '../utils/util';

const CERTIFICATE_CREATE_URL = '/certificate/create';
const CERTIFICATE_UPLOAD_URL = '/certificate/upload';

export class CertificateService {

    constructor(auth) {
        this.auth = auth;
    }

    async create(payload) {
        return await doFetch(CERTIFICATE_CREATE_URL, {
            method: 'POST',
            headers: toHeaders(this.auth),
            body: JSON.stringify(payload)
        });
    };

    async upload(payload) {
        return await doFetch(CERTIFICATE_UPLOAD_URL, {
            method: 'POST',
            headers: toHeaders(this.auth),
            body: JSON.stringify(payload)
        });
    };

    async createMany(payload) {
        return await doFetch(CERTIFICATE_CREATE_URL + '/many', {
            method: 'POST',
            headers: toHeaders(this.auth),
            body: JSON.stringify(payload)
        });
    };

    async uploadMany(payload) {
        return await doFetch(CERTIFICATE_UPLOAD_URL + '/many', {
            method: 'POST',
            headers: toHeaders(this.auth),
            body: JSON.stringify(payload)
        });
    };

}